import { callApi } from "./api";
import * as transforms from "./transforms";

// api services
export const fetchVariant = (id) => {
  return callApi("/product_variant/entity/" + id + "?_format=json").then(
    (response) => {
      if (response.response) {
        const output = transforms.transformProductVariant(response.response);
        return { response: output };
      } else {
        return { response: {} };
      }
    },
  );
};

export const fetchPrintColors = (layer_id, product_variant_id, print_type) => {
  if (!print_type) {
    //TODO change this so that it doesn't use an alert
    alert("Missing Print Type on one of the layer id " + layer_id);
    return { error: "Print Color Type is missing on layer id " + layer_id };
  }
  return callApi(
    "productvariant/" +
      product_variant_id +
      "/colors/print/" +
      print_type +
      "?_format=json",
  ).then((response) => {
    if (response.response) {
      return {
        response: {
          colors: transforms.transformColorsResponse(response.response),
          type: "Print",
          layer_id,
          print_type,
        },
      };
    } else {
      return { response: {} };
    }
  });
};
export const fetchPaperColors = (
  layer_id,
  product_variant_id,
  is_diecut,
  is_foldable,
  is_two_sided,
) => {
  return callApi(
    "productvariant/" +
      product_variant_id +
      "/colors/paper/" +
      (is_diecut ? 1 : 0) +
      "/" +
      (is_foldable ? 1 : 0) +
      "/" +
      (is_two_sided ? 1 : 0) +
      "?_format=json",
  ).then((response) => {
    if (response.response) {
      return {
        response: {
          colors: transforms.transformColorsResponse(response.response),
          type: "Paper",
          layer_id,
          is_diecut,
          is_foldable,
          is_two_sided,
        },
      };
    } else {
      return { response: {} };
    }
  });
};
